import React from "react";
import CryptoPoliticos from "../components/crypto-politicos/crypto2024";

const Version2024 = () => {
  return (
    <CryptoPoliticos />
  );
};

export default Version2024;